import ClipboardJS from 'clipboard';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { getMtaApBasicData, hydrateApBasicData } from './helpers/basicHelper';
import { webApkBaseUrl } from './helpers/config';
import { byId } from './helpers/utility';






authHelper.validate();
hydrateApBasicData();


const clipboard = new ClipboardJS('#basic-addon2');

clipboard.on('success', function (e) {


    e.clearSelection();
    Swal.fire({
        icon: 'success',
        title: 'Web App link Copied to Clipboard', toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
});


const webAppLinkInputElement = byId('webAppLinkInputElement');
const openLinkBtn = byId('openLinkBtn');





webAppLinkInputElement.value = `${webApkBaseUrl}/${getMtaApBasicData().appUsername}`;

const openLinkFun = async () => {
    window.open(webAppLinkInputElement.value, '_blank').focus();
};

openLinkBtn.addEventListener('click', openLinkFun);






